// 获得角色名称
export function getRoles(roles) {
  if (!roles || !Array.isArray(roles)) {
    return null;
  }
  return roles.map(item => item.name).join('、');
}
